export const getApiRequestAttempts = (request) => {
  if (!request) return { originalAttempt: null, retryAttempts: [] };

  let response = request.response_body;
  let history = [];
  if (response && typeof response === "object" && !Array.isArray(response)) {
    const { _retry_history, ...body } = response;
    history = Array.isArray(_retry_history) ? _retry_history : [];
    response = body;
    // The backend wraps non-object responses when adding retry history.
    if (
      history.length &&
      Object.keys(body).length === 1 &&
      "response" in body
    ) {
      response = body.response;
    }
  }

  const currentAttempt = {
    status_code: request.http_response_status_code,
    response,
  };

  return {
    originalAttempt: history.length ? history[0] : currentAttempt,
    retryAttempts: history.length ? [...history.slice(1), currentAttempt] : [],
  };
};
